import { useMutation } from "@apollo/client";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { useSnackbar } from "notistack";
import React from "react";
import { Test } from "../../graphql/baseTypes";
import { UPDATE_TEST_PERSON } from "../../graphql/mutations";
import { UpdateTestPersonDataMutation } from "../../graphql/mutations/updateTestPersonData";
import { UpdateTestPersonDataMutationVariables } from "../../graphql/types";
import TestForm, { TestFormValues } from "./TestForm";
interface Props {
  id: Pick<Test, "locationId" | "date" | "testId">;
  open: boolean;
  initialValues: TestFormValues;
  handleClose: () => any;
  params?: object;
}

const TestDialog: React.FC<Props> = ({
  open,
  handleClose,
  id,
  initialValues,
}) => {
  const { enqueueSnackbar } = useSnackbar();

  const [update, { loading: updateLoading }] = useMutation<
    UpdateTestPersonDataMutation,
    UpdateTestPersonDataMutationVariables
  >(UPDATE_TEST_PERSON, {
    onError(error) {
      console.log(error);
      enqueueSnackbar("Konnte Testpersonendaten nicht ändern", {
        variant: "error",
      });
    },
    onCompleted() {
      enqueueSnackbar("Tespersonendaten für Test geändert", {
        variant: "success",
      });

      handleClose();
    },
  });

  const handleSubmit = ({ identifier, insuranceNumber }: TestFormValues) => {
    const { date, locationId, testId } = id;
    return update({
      variables: {
        input: {
          testId,
          date,
          locationId,
          identifier,
          insuranceNumber,
        },
      },
    });
  };

  return (
    <Dialog
      open={open}
      disableBackdropClick={updateLoading}
      disableEscapeKeyDown={updateLoading}
      onClose={handleClose}
      aria-labelledby="test-dialog-title"
    >
      <DialogTitle id="test-title">
        Testpersonendaten für Test bearbeiten
      </DialogTitle>
      <DialogContent>
        <TestForm
          onSubmit={handleSubmit}
          loading={updateLoading}
          initi={initialValues}
        />
      </DialogContent>
    </Dialog>
  );
};

export default TestDialog;
